import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService.js';

export const useGetPhoneVerificationStatus = () => {
  return useQuery({
    staleTime: 1000 * 60, // 1 minute stale
    queryKey: [QUERY_KEYS.user.phone_verify],
    queryFn: () =>
      userService.phoneVerifyStatus().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
